/* eslint-disable quotes */
export const landing = {
  'answer-on-questions': 'Ответь на вопросы',
  'candidate-page-title': 'Анкета кандидата',
  'choose-vacancy': 'Выбери вакансию',
  'data-processing-and-agreement-links': `
    Я даю согласие на
    <a href="/pd_processing_policy_ru.pdf" class="text-primary-100" target="_blank">
      обработку моих персональных данных
    </a> с целью возможного трудоустройства и принимаю
    <a href="/user_agreement_sm_podbor_ru.pdf" class="text-primary-100" target="_blank">
    Пользовательское соглашение
    </a>`,
  'data-processing-and-agreement-links-am': `
    Я даю согласие на
    <a href="/pd_processing_policy_am_ru.pdf" class="text-primary-100" target="_blank">
      обработку моих персональных данных
    </a> с целью возможного трудоустройства и принимаю
    <a href="/user_agreement_sm_podbor_am_ru.pdf" class="text-primary-100" target="_blank">
    Пользовательское соглашение
    </a>`,
  'data-processing-and-agreement-links-kz': `
    Я даю согласие на
    <a href="/pd_processing_policy_kz_ru.pdf" class="text-primary-100" target="_blank">
      обработку моих персональных данных
    </a> с целью возможного трудоустройства и принимаю
    <a href="/user_agreement_sm_podbor_kz_ru.pdf" class="text-primary-100" target="_blank">
    Пользовательское соглашение
    </a>`,
  'data-processing-and-agreement-links-kg': `
    Я даю согласие на
    <a href="/pd_processing_policy_kg_ru.pdf" class="text-primary-100" target="_blank">
      обработку моих персональных данных
    </a> с целью возможного трудоустройства и принимаю
    <a href="/user_agreement_sm_podbor_kg_ru.pdf" class="text-primary-100" target="_blank">
    Пользовательское соглашение
    </a>`,
  'data-processing-and-agreement-links-uz': `
    Я даю согласие на
    <a href="/pd_processing_policy_uz_ru.pdf" class="text-primary-100" target="_blank">
      обработку моих персональных данных
    </a> с целью возможного трудоустройства и принимаю
    <a href="/user_agreement_sm_podbor_uz_ru.pdf" class="text-primary-100" target="_blank">
    Пользовательское соглашение
    </a>`,
  'do-you-lead-a-healthy-lifestyle': 'Ведёшь ли ты здоровый образ жизни?',
  'do-you-play-sport': 'Занимаешься ли ты спортом?',
  'type-full-name': 'Введи ФИО',
  'type-first-name': 'Введи имя',
  'type-last-name': 'Введи фамилию',
  'type-patronymic-name': 'Введи отчество',
  'full-name': 'ФИО',
  'error:birthday': 'Выбери дату рождения',
  'error:citizenship': 'Выбери гражданство',
  'error:city': 'Выбери город',
  'error:email': 'Введи E-Mail',
  'error:correct-email': 'Введи E-Mail',
  'error:type-full-name': 'Введи ФИО, разделяя пробелами фамилию, имя и отчество',
  'error:type-first-name': 'Введи имя',
  'error:type-last-name': 'Введи фамилию',
  'error:type-patronymic-name': 'Введи отчество',
  'error:expected-income-level': 'Введи ожидаемый уровень дохода',
  'error:phone': 'Введи телефон',
  'error:phone-number': 'Введи телефон',
  'error:prefered-communication-method': 'Выбери предпочитаемый способ связи',
  'error:prefered-schedule': 'Выбери график',
  'error:store': 'Выбери магазин',
  'error:recommender-full-name': 'Введи ФИО рекомендателя',
  'error:recommender-city': 'Введи город проживания рекомендателя',
  'expected-income-level': 'Ожидаемый уровень дохода, ₽',
  'fill-personal-data': 'Заполни личные данные',
  'fill-required-fields': 'Заполни обязательные поля!',
  'for-example-basketball': 'Например, баскетбол',
  'generating-telegram-link-please-wait': `Идёт формирование ссылки на телеграмм бота.
    Не покидай страницу, это может занять несколько секунд.`,

  'go-to-telegram': 'Перейти в Telegram',
  'if-you-have-trouble-to-fill-form': `Если у тебя возникли сложности с заполнением анкеты, звони 8 800 350-80-60`,
  'if-you-have-trouble-to-fill-form-email': `Если у тебя возникли сложности с заполнением анкеты - пиши
    <a href="mailto:Support_smpodbor@sportmaster.com">Support_smpodbor@sportmaster.com</a>`,
  'full-name-exemplicant': 'Иванов Иван Иванович',
  'first-name-exemplicant': 'Иван',
  'last-name-exemplicant': 'Иванов',
  'patronymic-name-exemplicant': 'Иванович',
  'link-our-telegram-for-more-info': `Переходи в наш
    <a :href="telegramLink" class="text-primary-100" target="_blank">Telegram</a>,
    чтобы быстрее получать информацию о дальнейших этапах собеседования`,

  'online-stage-personal-link-email': `На почту будет отправлена персональная
    ссылка для прохождения онлайн-этапа.`,

  'online-stage-video-recording-agreement': `Я даю согласие на запись видео
    во время прохождения онлайн-этапа.`,

  'phone-number': 'Номер телефона',
  'prefered-communication-method': 'Предпочитаемый способ связи',
  'prefered-schedule': 'Желаемый график',
  'previous-step': 'Предыдущий шаг',
  'profile-vk': 'Профиль VK',
  'questionnaire-sent-successfully': 'Анкета успешно отправлена',
  'online-stage-personal-link-sent-on-your-email': `На твою почту
    <strong>{userEmail}</strong> отправлена персональная ссылка на прохождение онлайн-этапа`,
  'sales-representative': 'Торговый представитель',
  'system-administrator': 'Системный администратор',
  'type-birthday': 'Введи дату рождения',
  'type-profile-vk-link': 'Введи ссылку на профиль VK',
  'write-what-sport-do-you-do': 'Например, баскетбол',
  'fill-questionnaire': 'Заполните данные в анкете',
  birthday: 'Дата рождения',
  citizenship: 'Гражданство',
  city: 'Город',
  loader: 'Грузчик',
  next: 'Далее',
  partner: 'Партнер',
  phone: 'Телефон',
  email: 'E-mail',
  step: 'Шаг',
  store: 'Магазин',
  ITN: 'ИНН',
  MSRN: 'ОГРН',
  code: 'Код',
  'send-questionnaire': 'Отправить анкету',
  'recommender-data-title': 'Данные рекомендателя',
  'has-work-in-this-company-before': 'Ранее работал в Спортмастер',
};
